import { createFileRoute } from '@tanstack/react-router'
import { EducationPageStructured } from '@/components/infoPages/EducationPageStructured'
import { withPublicPageSeo } from '@/modules/seo'

const EducationPageWithSeo = withPublicPageSeo('forEducation', EducationPageStructured)

export const Route = createFileRoute('/$lang/for-education')({ component: EducationPageWithSeo })
